export default __webpack_public_path__ + "static/media/creation_animation.d47776a5.riv";